import { render, staticRenderFns } from "./DevotionalCompletionRanks-Single.vue?vue&type=template&id=87548022&"
import script from "./DevotionalCompletionRanks-Single.vue?vue&type=script&lang=js&"
export * from "./DevotionalCompletionRanks-Single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports